import React from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import emailjs from 'emailjs-com';

function LHSection() {

    const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    projectDetails: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        {
          full_name: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          project_details: formData.projectDetails,
        },
        "YOUR_PUBLIC_KEY"
      )
      .then(
        () => {
          alert("Message sent successfully!");
          setFormData({
            fullName: "",
            email: "",
            phone: "",
            projectDetails: "",
          });
        },
        (error) => {
          alert("Failed to send message. Try again.");
          console.error(error);
        }
      );
  };
  return (
    <div>
      <div className="relative bg-black/40 w-full overflow-x-hidden">
  {/* Background Video Section */}
  <video
    className="absolute inset-0 w-full h-full object-cover"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
  </video>
  <div className="absolute inset-0 bg-black bg-opacity-30" />
  <div className="w-full">
    <div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
      
      {/* Text Section */}
      <motion.div
        initial={{ x: '100%' }}
        whileInView={{ x: '0%' }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
        viewport={{ once: true }}
        className="md:w-1/2 relative"
      >
        <div className="overflow-hidden">
          <motion.div
      initial={{ clipPath: "inset(0 100% 0 0)" }}
      whileInView={{ clipPath: "inset(0 0% 0 0)" }}
      transition={{ duration: 1.2, ease: "easeInOut", delay: 1 }}
      viewport={{ once: true }}
      className="bg-white/90 p-8 rounded-lg shadow-lg"
    >
      <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-slate-900">
        Get In Touch With Us
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

        <textarea
          name="projectDetails"
          placeholder="Project Details"
          value={formData.projectDetails}
          onChange={handleChange}
          rows="4"
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          required
        />

         <button className="relative inline-block px-4 py-2 text-xl font-semibold text-white bg-slate-900  overflow-hidden group w-full">
            <span className="absolute inset-0 bg-gradient-to-r from-teal-600 to-teal-600 transition-all duration-500 ease-in-out group-hover:w-full group-hover:left-0 animate-slide-bg"></span>
            <span className="relative z-10 group-hover:text-white transition-colors duration-300">
              Contact
            </span>
              </button>

      </form>
    </motion.div>
        </div>
      </motion.div>

      {/* Image Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="md:w-1/2 relative group"
      >
        {/* Wrapper to contain animated frames and prevent overflow */}
        <div className="relative">
  {/* Frames go outside the image */}
  {/* Top-left animated frame */}
  <motion.div
    animate={{ y: [0, -18, 2, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute top-0 left-0 -translate-x-4 -translate-y-4 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-teal-500 z-10"
  />
  {/* Bottom-right animated frame */}
  <motion.div
    animate={{ y: [0, 18, -2, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute bottom-0 right-0 translate-x-4 translate-y-4 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-teal-500 z-10"
  />

  {/* Image container */}
  <div className="relative overflow-hidden shadow-2xl">
    <img
      src="/assets/images/our-process-contact-img.png"
      alt="What We Do"
      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
    />
    {/* Overlay */}
    <div className="absolute inset-0 bg-teal-500 bg-opacity-5 pointer-events-none" />
  </div>
</div>

      </motion.div>
    </div>
  </div>
</div>
    </div>
  )
}

export default LHSection
